import { Grid, Tooltip, useMediaQuery, useTheme, IconButton } from "@material-ui/core";
import { Edit, ExitToAppOutlined, SyncAlt, FileCopyOutlined } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import PaymentIcon from "@material-ui/icons/Payment";
import PrintIcon from "@material-ui/icons/Print";
import SendIcon from "@material-ui/icons/Send";
import {
  ASYNC_DATA_CRM_PATIENT,
  CHECKIN_IN_FORM_PATIENT,
  IMAGE_SIZE,
  PAYMENT_METHOD_LIMITS,
  SHOW_EXPENSE_OCCURRED,
} from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import PatientComplainChip from "app/common/Component/PatientComplainChip";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconMedicalHistory from "app/common/Icon/EyeTestTabs/IconMedicalHistory";
import {
  FEE_TAB,
  RANK_LIST,
  REGISTER_TREATMENT_TAB,
  TREATMENT_TAB,
} from "app/common/LocalConst";
import {
  ItemForcus,
  convertKbToMb,
  getAge,
  getCustomerStatus,
  getDate,
  getDateTime,
  getDisplayAddress,
  getGender,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleTechician,
  formatPhoneDisplayValue,
  handleCopyPhone,
  isRoleHisCopyPhone,
} from "app/common/LocalFunction";
import ViewImageAvatar from "app/common/ViewImageAvatar";
import { createPatient } from "app/services/PatientService";
import { uploadAlbum } from "app/services/VisitService";
import { useStore } from "app/stores";
import { Form, Formik, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import PopupPrintAllTab from "./PatientGeneralTabs/RegisterServiceTreatmentPlanTab/PrintTreatmentPlanTab/PopupPrintAllTab";
function PatientGeneralInfo({
  patientId,
  initialPatient,
  currentTab,
  setCurrentTab,
}) {
  let currentRoomBed = "";
  if (initialPatient?.patientInfo?.currentBedName) {
    currentRoomBed = initialPatient?.patientInfo?.currentBedName;
  }
  if (initialPatient?.patientInfo?.currentRoomName) {
    if (currentRoomBed) currentRoomBed += " - ";
    currentRoomBed += initialPatient?.patientInfo?.currentRoomName;
  }
  const {
    openPopupPrintAll,
    handleOpenPopupPrintAll,
    handleClosePrintTreatmentPlan,
    allServicePatientData,
  } = useStore().patientManagementStore.registerTreatmentPlanStore;

  useEffect(() => {
    if (patientId) {
      document.title =
        initialPatient?.patientInfo?.displayName ||
        "Thẩm mỹ viện Quốc tế Linh Anh";
    }
    return () => {
      document.title = "Thẩm mỹ viện Quốc tế Linh Anh";
    };
  }, [initialPatient?.patientInfo]);
  return (
    <Grid component="section" item xs={12} md={12}>
      <Formik
        initialValues={{
          patientAvatarId: initialPatient?.patientInfo?.patientAvatarId,
        }}
        onSubmit={(values) => { }}
        enableReinitialize
      >
        <Form autoComplete="off">
          <ValueForm
            patient={initialPatient?.patientInfo}
            patientId={patientId}
            handleOpenPopupPrintAll={handleOpenPopupPrintAll}
            openPopupPrintAll={openPopupPrintAll}
            handleClosePrintTreatmentPlan={handleClosePrintTreatmentPlan}
            allServicePatientData={allServicePatientData}
            initialPatient={initialPatient}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
        </Form>
      </Formik>
    </Grid>
  );
}

const ValueForm = ({
  patient,
  patientId,
  handleOpenPopupPrintAll,
  openPopupPrintAll,
  handleClosePrintTreatmentPlan,
  allServicePatientData,
  initialPatient,
  currentTab,
  setCurrentTab,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isFirstTab = currentTab === 0;
  const { t } = useTranslation();
  const additionalPhones = [
    patient?.subPhoneNumber,
    patient?.phoneNumber3,
    patient?.phoneNumber4,
  ].filter(Boolean);
  const {
    handleOpenFormCreateOrEdit,
    handleOpenFormCheckIn,
    handleOpenFormCheckOut,
  } = useStore().patientManagementStore.patientListStore;
  const {
    handleGetPatientOverviewByIdNotLoading,
    handleAsyncDataCrmPatient,
    customerSourceWalkIn,
    handleOpenHistoryPatientPopup,
    getDataInvoiceDebtFee,
  } = useStore().patientManagementStore.patientGeneralStore;
  const defaultDepartment = useDefaultDepartment();

  const { handleOpenCreateOrEditTreatmentPlanPopup } =
    useStore().patientManagementStore.registerTreatmentPlanStore;

  const { handleOpenServiceFeePopup } = useStore().feeStore.serviceFeeTabStore;
  const { handleOpenPopupHistoryChangeRemain } =
    useStore().feeStore.historyChangeRemainTabStore;

  const {
    handleOpenUncompletedServicePopup,
    handleOpenUncompletedServicePopupReadOnly,
  } = useStore().patientManagementStore.uncompletedRegisterServiceStore;
  const inputRef = useRef(null);

  const { setFieldValue, values } = useFormikContext();

  const handleClearImage = async () => {
    setFieldValue(`patientAvatarId`, null);
    await createPatient({
      ...patient,
      patientAvatarId: null,
    });
    await handleGetPatientOverviewByIdNotLoading(patient?.id);
  };

  const handleAddImages = (id) => {
    // const newList = [...files.map((file) => ({ fileDescription: file }))];
    setFieldValue("patientAvatarId", id);
  };

  async function uploadImages(e) {
    if (!e?.target?.files?.length) {
      toast.warning("Vui lòng chọn ảnh để tải lên");
      return;
    }
    const files = Array.from(e.target.files);
    const oversizedFiles =
      files.filter((file) => file?.size <= IMAGE_SIZE) || [];

    if (oversizedFiles.length > 0 && oversizedFiles.length < files?.length) {
      toast.warning(
        `Một số ảnh có kích thước vượt quá ${convertKbToMb(
          IMAGE_SIZE
        )}, hệ thông sẽ nhận những ảnh có kích thước dưới ${convertKbToMb(
          IMAGE_SIZE
        )}`
      );
    } else if (oversizedFiles.length === 0) {
      toast.warning(
        `Những hình ảnh có kích thước vượt quá ${convertKbToMb(
          IMAGE_SIZE
        )}, hệ thông chỉ nhận những ảnh có kích thước dưới ${convertKbToMb(
          IMAGE_SIZE
        )}`
      );
    }

    try {
      let { data: uploadedImages } = await uploadAlbum(oversizedFiles);
      if (uploadedImages.length > 0) {
        handleAddImages(uploadedImages?.[0]?.id);
        await createPatient({
          ...patient,
          patientAvatarId: uploadedImages?.[0]?.id,
        });
        await handleGetPatientOverviewByIdNotLoading(patient?.id);
        toast.success("Tải lên thành công");
      } else {
        toast.error("Không có ảnh nào được tải lên");
      }
    } catch (error) {
      toast.error("Đã xảy ra lỗi trong quá trình tải ảnh");
    }
  }
  let color_rank =
    RANK_LIST.find((el) => patient?.currentPatientRank?.code === el?.code)
      ?.color || "#219d77";

  const totalToReceive = initialPatient?.totalAmountToReceive;
  const totalReceived = initialPatient?.totalAmountReceived;
  const missingAmount = totalToReceive - totalReceived;

  const formatMoneyVND = (amount) => {
    if (amount == null) return "0";
    return new Intl.NumberFormat("vi-VN", {
      maximumFractionDigits: 0,
    }).format(amount);
  };
  const [isOpenFillter, setOpenFillter] = useState(false);
  const isReadonly = isRoleHisReadOnly();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isRoleBranchManagers = isRoleBranchManager();
  const isDoctors = isDoctor();
  const isCashier = isRoleCashier();
  const isAccountant = isRoleHisAccountant();

  const isTablet = useMediaQuery("(min-width:960px) and (max-width:1279px)");
  const isTablets = useMediaQuery(theme.breakpoints.down("md"));
  // Tổng tiền thẻ còn lại có thể dùng = được dùng - đã dùng
  const cardAvailable =
    (initialPatient?.totalCardAmount || 0) -
    (initialPatient?.usedCardAmount || 0);
  // Tổng tiền cọc còn lại có thể dùng =  được dùng -  đã dùng
  const depositAvailable =
    (initialPatient?.totalDeposit || 0) -
    (initialPatient?.usedDepositAmount || 0);

  return (
    <Grid
      container
      className="cards-container patient-info-container pl-2 pr-2 h-100"
      style={{ justifyContent: "center" }}
      spacing={1}
    >
      {(!isMobile || isFirstTab) && (
        <Grid item xs={12} sm={6} md={isTablet ? 2 : 1}>
          <input
            type="file"
            onChange={uploadImages}
            className="display-none"
            ref={inputRef}
            accept="image/*"
          />

          <div
            className="flex align-center flex-column "
            style={{
              ...(isTablet && {
                width: "100%",
                alignItems: "center",
              }),
            }}
          >
            <ViewImageAvatar
              heightImg={isTablet ? "180px" : "100px"}
              widthImg={isTablet ? "180px" : "100px"}
              fileDescriptionId={values?.patientAvatarId}
              handleClearImage={handleClearImage}
              name={patient?.displayName}
            />
            <div className="flex gap-2 align-center">
              {!isReadonly && (
                <CommonButton
                  className="btn-primary mt-1"
                  onClick={() => inputRef.current.click()}
                  style={{
                    ...(isTablet && {
                      width: "100%",
                    }),
                  }}
                >
                  <CloudDownloadIcon />
                </CommonButton>
              )}

              {isMobile && (
                <>
                  {CHECKIN_IN_FORM_PATIENT && (
                    <div
                      onClick={() => {
                        handleOpenFormCheckIn(patient);
                      }}
                      className={"flex align-center gap-1 group-icon-btn"}
                    >
                      <SendIcon className="mr-1 color-primary-icon" />{" "}
                      {!isMobile && "Check in"}
                    </div>
                  )}
                  {/* <span className="spacing-item"></span> */}
                  <Tooltip title={"Xem lịch sử khách hàng"}>
                    <div
                      className={"flex align-center gap-1 group-icon-btn mt-1"}
                      onClick={() =>
                        handleOpenHistoryPatientPopup({
                          id: initialPatient?.patientInfo?.id,
                        })
                      }
                    >
                      <div className="flex align-center">
                        <IconMedicalHistory
                          color="blue"
                        // style={{ width: "20px", height: "20px" }}
                        />
                      </div>
                      {/* {!isMobile && "Lịch sử khách hàng"} */}
                      {/* {"Lịch sử khách hàng"} */}
                    </div>
                  </Tooltip>
                </>
              )}
            </div>
          </div>
        </Grid>
      )}

      <Grid
        item
        xs={12}
        md={isTablet ? 10 : 11}
        style={{ paddingLeft: isTablet ? 25 : 0 }}
      >
        <Grid
          container
          spacing={1}
          className={`info-name flex align-center ${isMobile && "flex-center"}`}
        >
          <Grid item lg={12} style={{ marginTop: "10px" }}>
            <Grid container spacing={1} className="flex-between">
              {(!isMobile || isFirstTab) && (
                <>
                  <Grid
                    item
                    xs={12}
                    lg={3}
                    md={4}
                    className="flex gap-1 justify-between align-center"
                  >
                    <ItemForcus
                      style={{ textAlign: "center" }}
                      label="Họ và Tên"
                      value={
                        <span className="flex align-center flex-wrap gap-1">
                          <span>
                            {`${patient?.displayName}${patient?.birthDate &&
                              new Date(patient?.birthDate) > new Date("1920-01-01")
                              ? ` - ${getAge(patient?.birthDate)}`
                              : ""
                              }${(!isMobile || isFirstTab) && patient?.gender
                                ? ` - ${getGender(patient?.gender)}`
                                : ""
                              }`}
                          </span>
                          <PatientComplainChip
                            complainStatus={patient?.complainStatus}
                          />
                        </span>
                      }
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label="Ngày sinh"
                      value={getDate(patient?.birthDate)}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <div className="flex align-center">
                      <ItemForcus
                        label={t("SĐT 1")}
                        value={patient?.phoneNumber}
                      />
                      {patient?.phoneNumber && isRoleHisCopyPhone() && (
                        <Tooltip title="Copy số điện thoại">
                          <IconButton
                            size="small"
                            onClick={() => handleCopyPhone(patient?.phoneNumber)}
                            style={{ marginLeft: 4, padding: 2 }}
                          >
                            <FileCopyOutlined fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    lg={3}
                    md={4}
                    className="flex justify-between align-center"
                  >
                    <p className="flex align-start">
                      <span className="mr-1" style={{ whiteSpace: "nowrap" }}>
                        SĐT 2|3|4:{" "}
                      </span>
                      <strong className="flex-center flex-wrap">
                        {additionalPhones.length > 0 ? (
                          additionalPhones.map((phone, index) => (
                              <span
                                key={`${phone}-${index}`}
                                className="flex align-center"
                              >
                                {index > 0 && (
                                  <span style={{ margin: "0 4px" }}>|</span>
                                )}
                                <span>{formatPhoneDisplayValue(phone)}</span>
                                {isRoleHisCopyPhone() && (
                                  <Tooltip title="Copy số điện thoại">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleCopyPhone(phone)}
                                      style={{ marginLeft: 2, padding: 2 }}
                                    >
                                      <FileCopyOutlined fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </span>
                            ))
                        ) : (
                          "(---)"
                        )}
                      </strong>
                    </p>
                  </Grid>

                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus label={t("Mã Kh")} value={patient?.code} />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4} className="flex ">
                    <ItemForcus
                      label={t("Nguồn hiện tại")}
                      value={patient?.currentPatientSource?.name}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4} className="flex ">
                    <ItemForcus
                      label={t("Cơ sở hiện thời KH")}
                      value={patient?.currentDepartmentName}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("CTV")}
                      value={initialPatient?.patientInfo?.referralPartnerName}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3} md={4}>
                    <ItemForcus
                      label={t("Telesale hiện thời")}
                      value={patient?.currentTelesale?.staffName}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3} md={4}>
                    <ItemForcus
                      label={t("Loại khách hàng")}
                      value={getCustomerStatus(patient?.customerStatus)}
                    />
                  </Grid>
                </>
              )}

              {isOpenFillter && (
                <>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Đối tượng")}
                      value={patient?.currentPatientTypeService?.name}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3} md={4}>
                    <ItemForcus
                      label={t("Địa chỉ")}
                      value={getDisplayAddress(patient)}
                    />
                  </Grid>

                  <Grid item xs={12} lg={3} md={4}>
                    <ItemForcus
                      label={t("patient.profession")}
                      value={patient?.profession?.name}
                    />
                  </Grid>

                  {/* lý có 2 Telesale2 ở đây là để hiện ở vị trí này 1 đối với role only và các role khác */}
                  {!isReadonly && (
                    <Grid item xs={6} lg={3} md={4} className="flex gap-1">
                      <ItemForcus
                        label={t("Telesale 2 (cũ)")}
                        value={patient?.currentTelesale2?.staffName}
                      />
                    </Grid>
                  )}
                  {isReadonly && (
                    <Grid item xs={6} lg={3} md={4} className="flex gap-1">
                      <ItemForcus
                        label={t("Telesale 2 (cũ)")}
                        value={patient?.currentTelesale2?.staffName}
                      />
                    </Grid>
                  )}
                  <Grid item xs={6} lg={3} md={4} className="flex gap-1">
                    <ItemForcus
                      label={t("Loại KH")}
                      value={patient?.currentPatientType?.name}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4} className="flex">
                    <ItemForcus
                      label={t("Nhóm KH")}
                      value={patient?.currentPatientGroup?.name}
                    />
                  </Grid>
                  {(!isMobile || isFirstTab) && (
                    <>
                      <Grid item xs={6} lg={3} md={4}>
                        <ItemForcus
                          label={t("CSKH hiện thời")}
                          value={patient?.currentCustomerCareAgent?.staffName}
                        />
                      </Grid>
                      <Grid item xs={6} lg={3} md={4}>
                        <ItemForcus
                          label={t("Nguồn đầu tiên")}
                          value={patient?.firstPatientSource?.name}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Nguồn hiện tại (Chi tiết)")}
                      value={patient?.currentPatientSourceDetail?.name}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Nguồn đầu tiên (Chi tiết)")}
                      value={patient?.firstPatientSourceDetail?.name}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Ngày giờ tạo")}
                      value={getDateTime(patient?.createDate)}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Người tạo")}
                      value={initialPatient?.createdBy}
                    />
                  </Grid>

                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Người Checkin")}
                      value={
                        patient?.currentConsultant?.staffName ||
                        initialPatient?.checkinList?.[0]?.practitioner
                          ?.staffName
                      }
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={6} lg={3} md={4}></Grid>
              <Grid item xs={6} lg={3} md={4}></Grid>
            </Grid>
          </Grid>

          {/* tiền */}
          {(!isMobile || isFirstTab) &&
            (!Array.isArray(PAYMENT_METHOD_LIMITS) ||
              PAYMENT_METHOD_LIMITS.length === 0) && (
              <>
                <Grid item lg={12}>
                  <Grid container spacing={1} className="patient-money-info">
                    <Grid item xs={6} sm={6} md={3} lg={2}>
                      <div className="field">
                        <Tooltip title="TỔNG TIỀN CỌC ĐƯỢC DÙNG">
                          <div className="flex align-center gap-1">
                            <label>Tiền cọc còn lại</label>
                            <span class="badge badge-light-blue">
                              {formatMoneyVND(depositAvailable)}
                            </span>
                            {/* <ExpandMore
                            color="#4276a4"
                            style={{ width: "18px", marginBottom: "2px" }}
                          /> */}
                          </div>
                        </Tooltip>
                        {/* <Tooltip title="Tổng tiền cọc đã dùng">
                        <div>
                          <span class="badge badge-purple">
                            {formatMoneyVND(depositAvailable)}
                          </span>
                        </div>
                      </Tooltip> */}
                      </div>
                    </Grid>

                    <Grid item xs={6} sm={6} md={3} lg={2}>
                      <div className="field">
                        <Tooltip title="TỔNG TIỀN THẺ ĐƯỢC DÙNG">
                          <div className="flex align-center gap-1">
                            <label>Tiền thẻ còn lại</label>
                            <span class="badge badge-light-blue">
                              {formatMoneyVND(cardAvailable)}
                            </span>
                            {/* <ExpandMore
                            color="#4276a4"
                            style={{ width: "18px", marginBottom: "2px" }}
                          /> */}
                          </div>
                        </Tooltip>
                        {/* <Tooltip title="TỔNG TIỀN THẺ ĐƯỢC DÙNG">
                        <div>
                          <span class="badge badge-yellow">
                            {formatMoneyVND(cardAvailable)}
                          </span>
                        </div>
                      </Tooltip> */}
                      </div>
                    </Grid>

                    {/*dịch vụ còn lại  */}
                    <Grid item xs={6} sm={6} md={3} lg={2}>
                      <div className="field">
                        <Tooltip title="Số lượng DV chưa điều trị xong">
                          <div
                            className="flex align-center gap-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleOpenUncompletedServicePopupReadOnly();
                            }}
                          >
                            <label>DV còn điều trị</label>
                            <span class="badge badge-light-blue">
                              {initialPatient?.numberOfServiceNotCompleted || 0}
                            </span>
                            {/* <ExpandMore
                            color="#4276a4"
                            style={{ width: "18px", marginBottom: "2px" }}
                          /> */}
                          </div>
                        </Tooltip>
                        {/* <Tooltip title="DỊCH VỤ CÒN LẠI">
                        <div>
                          <span class="badge badge-green">
                            {initialPatient?.numberOfServiceNotCompleted}
                          </span>
                        </div>
                      </Tooltip> */}
                      </div>
                    </Grid>

                    {SHOW_EXPENSE_OCCURRED && (
                      <Grid item xs={6} sm={6} md={3} lg={2}>
                        <div className="field">
                          <Tooltip title="Đã phát sinh">
                            <div
                              className="flex align-center gap-1"
                              style={{ cursor: "pointer" }}
                            >
                              <label>Đã phát sinh</label>
                              <span class="badge badge-light-blue">
                                {formatMoneyVND(
                                  initialPatient?.totalIncurredAmount
                                )}
                              </span>
                            </div>
                          </Tooltip>
                        </div>
                      </Grid>
                    )}

                    {/* đã thanh toán  */}
                    <Grid item xs={6} sm={6} md={3} lg={2}>
                      <div className="field">
                        <Tooltip title="ĐÃ THANH TOÁN">
                          <div className="flex align-center gap-1">
                            <label>Đã thanh toán</label>
                            <span class="badge badge-light-blue">
                              {formatMoneyVND(initialPatient?.totalRevenue)}
                            </span>
                            {/* <ExpandMore
                            color="#4276a4"
                            style={{ width: "18px", marginBottom: "2px" }}
                          /> */}
                          </div>
                        </Tooltip>
                        {/* <Tooltip title="ĐÃ THANH TOÁN">
                        <div>
                          <span class="badge badge-pink">
                            {formatMoneyVND(initialPatient?.totalRevenue)}
                          </span>
                        </div>
                      </Tooltip> */}
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={2}>
                      <div className="field">
                        <Tooltip title="CÒN NỢ">
                          <div
                            className="flex align-center gap-1"
                            onClick={() => {
                              getDataInvoiceDebtFee({
                                patientId,
                                patient,
                              });
                            }}
                          >
                            <label>Còn nợ</label>
                            <span class="badge badge-pink">
                              {formatMoneyVND(missingAmount || 0)}
                            </span>
                          </div>
                        </Tooltip>
                      </div>
                    </Grid>

                    <Grid item xs={6} sm={6} md={3} lg={2}>
                      <div className="field">
                        <Tooltip title="Điểm tích lũy">
                          <div className="flex align-center gap-1">
                            <label>Điểm tích lũy</label>
                            <span class="badge badge-pink">
                              {initialPatient?.clientReward?.pointsEarned || 0}
                            </span>
                          </div>
                        </Tooltip>
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={2}>
                      <div className="field">
                        <Tooltip title="Số dư LT cũ">
                          <div
                            className="flex align-center gap-1"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleOpenPopupHistoryChangeRemain({
                                patientId,
                                isStillValid: true,
                              })
                            }
                          >
                            <label>Số dư LT cũ</label>
                            <span class="badge badge-pink">
                              {formatMoneyVND(
                                initialPatient?.remainingOrderAmount || 0
                              )}
                            </span>
                          </div>
                        </Tooltip>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
        </Grid>
        {/* phần này là các nút thao tác */}
        {(!isMobile || isFirstTab) && (
          <Grid
            item
            lg={12}
            style={{ borderTop: "1px solid #ccc", marginTop: "8px" }}
          >
            <div
              className={`flex justify-end`}
              style={{
                gap: isMobile ? "9px" : "12px",
                justifyContent: isMobile ? "center" : "",
                marginTop: "5px",
              }}
            >
              {!isReadonly && (
                <>
                  {!isMobile && CHECKIN_IN_FORM_PATIENT && (
                    <>
                      <div
                        onClick={() => {
                          if (initialPatient?.patientInfo?.id) {
                            handleOpenFormCheckIn(patient);
                          }
                        }}
                        className={"flex align-center gap-1 group-icon-btn"}
                      >
                        <SendIcon className="mr-1 color-primary-icon" />{" "}
                        {!isMobile && !isTablets && "Check in"}
                      </div>
                      <span className="spacing-item"></span>
                    </>
                  )}

                  {(isAdmins ||
                    isCashier ||
                    isRoleBranchManagers ||
                    isAccountant) && (
                      <Tooltip arrow title={"Thêm liệu trình"}>
                        <div
                          onClick={() => {
                            handleOpenCreateOrEditTreatmentPlanPopup(
                              null,
                              initialPatient?.patientInfo,
                              customerSourceWalkIn,
                              defaultDepartment
                            );
                            setCurrentTab(REGISTER_TREATMENT_TAB);
                          }}
                          className={"flex align-center gap-1 group-icon-btn"}
                        >
                          <AddIcon className="mr-1 color-primary-icon" />{" "}
                          {!isMobile && !isTablets && "Lên LT"}
                        </div>
                      </Tooltip>
                    )}

                  <span className="spacing-item"></span>

                  {(isAdmins ||
                    isCashier ||
                    isRoleBranchManagers ||
                    isAccountant) && (
                      <>
                        <Tooltip arrow title={"Chỉ định điều trị"}>
                          <div
                            onClick={() => {
                              setCurrentTab(TREATMENT_TAB);
                              setTimeout(() => {
                                if (initialPatient?.patientInfo?.id) {
                                  handleOpenUncompletedServicePopup();
                                }
                              }, 0);
                            }}
                            className={"flex align-center gap-1 group-icon-btn"}
                          >
                            <AssignmentIcon className="mr-1 color-primary-icon" />{" "}
                            {!isMobile && !isTablets && "Chỉ định"}
                          </div>
                        </Tooltip>
                        <span className="spacing-item"></span>
                      </>
                    )}

                  {(isAdmins ||
                    isCashier ||
                    isRoleBranchManagers ||
                    isAccountant) && (
                      <>
                        <Tooltip arrow title={"Thanh toán"}>
                          <div
                            onClick={() => {
                              handleOpenServiceFeePopup({
                                patient: initialPatient?.patientInfo,
                              });
                              setCurrentTab(FEE_TAB);
                            }}
                            className={"flex align-center gap-1 group-icon-btn"}
                          >
                            <PaymentIcon className="mr-1 color-primary-icon" />{" "}
                            {!isMobile && !isTablets && "Thanh toán"}
                          </div>
                        </Tooltip>
                        <span className="spacing-item"></span>
                      </>
                    )}

                  {(isAdmins ||
                    isCashier ||
                    isRoleBranchManagers ||
                    isAccountant) && (
                      <>
                        <div
                          onClick={() => {
                            handleOpenFormCreateOrEdit(patient);
                          }}
                          className={"flex align-center gap-1 group-icon-btn"}
                        >
                          <Edit className="mr-1 color-primary-icon" />{" "}
                          {!isMobile && !isTablets && "Chỉnh sửa thông tin"}
                        </div>
                        <span className="spacing-item"></span>
                      </>
                    )}

                  <Tooltip
                    arrow
                    title={"In dịch vụ lẻ - thẻ - liệu trình - sản phẩm"}
                  >
                    <div
                      onClick={() => {
                        if (initialPatient?.patientInfo?.id) {
                          handleOpenPopupPrintAll(patientId);
                        }
                      }}
                      className={"flex align-center gap-1 group-icon-btn"}
                    >
                      <PrintIcon className="mr-1 color-primary-icon" />{" "}
                      {!isMobile && !isTablets && " In tất cả phiếu"}
                    </div>
                  </Tooltip>
                  <span className="spacing-item"></span>
                  <div
                    onClick={() => {
                      handleOpenFormCheckOut(patient);
                    }}
                    className={"flex align-center gap-1 group-icon-btn"}
                  >
                    <ExitToAppOutlined className="mr-1 color-primary-icon" />{" "}
                    {!isMobile && !isTablets && "Check out"}
                  </div>
                  <span className="spacing-item"></span>

                  <Tooltip arrow title={"Xem chi tiết thông tin khách hàng"}>
                    <span
                      className={"flex align-center gap-1 group-icon-btn"}
                      color={"white"}
                      onClick={() => setOpenFillter(!isOpenFillter)}
                    >
                      <p style={{ fontSize: "20px" }}>⛶</p>
                      {!isMobile && !isTablets && " Xem thêm"}
                    </span>
                  </Tooltip>

                  <span className="spacing-item"></span>

                  {!isMobile && (
                    <Tooltip title={"Xem lịch sử khách hàng"}>
                      <div
                        className={"flex align-center gap-1 group-icon-btn"}
                        onClick={() =>
                          handleOpenHistoryPatientPopup({
                            id: initialPatient?.patientInfo?.id,
                          })
                        }
                      >
                        <div className="flex align-center">
                          <IconMedicalHistory
                            color="blue"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </div>
                        {!isMobile && !isTablets && "Lịch sử khách hàng"}
                      </div>
                    </Tooltip>
                  )}

                  {ASYNC_DATA_CRM_PATIENT && (
                    <>
                      <span className="spacing-item"></span>

                      <Tooltip arrow title={"Đồng bộ DL cũ"}>
                        <div
                          onClick={() => {
                            handleAsyncDataCrmPatient(patient);
                          }}
                          className={"flex align-center gap-1 group-icon-btn"}
                        >
                          <SyncAlt className="mr-1 color-primary-icon" />{" "}
                          {!isMobile && !isTablets && "Đồng bộ DL cũ"}
                        </div>
                      </Tooltip>
                    </>
                  )}
                </>
              )}

              {/* để nút này ở đây cho cả readonly thấy nút  */}
              {isReadonly && (
                <Tooltip arrow title={"Xem chi tiết thông tin khách hàng"}>
                  <span
                    className={"flex align-center gap-1 group-icon-btn"}
                    color={"white"}
                    onClick={() => setOpenFillter(!isOpenFillter)}
                  >
                    <p style={{ fontSize: "20px" }}>⛶</p>
                    {!isMobile && " Xem thêm"}
                  </span>
                </Tooltip>
              )}
            </div>
          </Grid>
        )}
      </Grid>

      {openPopupPrintAll && (
        <PopupPrintAllTab
          open={openPopupPrintAll}
          handleClose={() => {
            handleClosePrintTreatmentPlan();
          }}
          allServicePatientData={allServicePatientData}
        />
      )}
    </Grid>
  );
};

export default memo(observer(PatientGeneralInfo));
